import { render, staticRenderFns } from "./createAccountModal.vue?vue&type=template&id=c642a7a6&scoped=true&"
import script from "./createAccountModal.vue?vue&type=script&lang=js&"
export * from "./createAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./createAccountModal.vue?vue&type=style&index=0&id=c642a7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c642a7a6",
  null
  
)

export default component.exports